module.exports = __webpack_public_path__ + "static/media/vehicles.321f3ba6.png";